var _defs, _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#43527a}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 19.07,
    cy: 36.78,
    r: 2.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 13.59,
    cy: 6.23,
    r: 2.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.51 18.09a7.001 7.001 0 0 0-9.9 0c-.52.52-.95 1.11-1.28 1.75l-9.17-7.32a6.876 6.876 0 0 0 1.34-4.08c0-3.81-3.1-6.92-6.92-6.92s-6.92 3.1-6.92 6.92c0 3.81 3.1 6.92 6.92 6.92 1.77 0 3.38-.68 4.61-1.78l9.6 7.67a7.001 7.001 0 0 0 2.49 7.32l-6.61 5.27a6.896 6.896 0 0 0-4.61-1.78c-3.82 0-6.92 3.1-6.92 6.91s3.1 6.92 6.92 6.92 6.92-3.1 6.92-6.92c0-1.53-.5-2.93-1.34-4.08l6.94-5.53a7.001 7.001 0 0 0 7.92-11.29Zm-21.84-6.01c-.43-1.79-2.09-2.94-4.08-2.94s-3.65 1.15-4.08 2.94c-.86-.97-1.4-2.25-1.4-3.64 0-3.02 2.46-5.48 5.48-5.48 3.02 0 5.48 2.46 5.48 5.48 0 1.4-.53 2.67-1.4 3.64Zm5.48 30.55c-.43-1.79-2.09-2.94-4.08-2.94s-3.65 1.15-4.08 2.94a5.467 5.467 0 0 1-1.39-3.64c0-3.02 2.46-5.48 5.48-5.48s5.48 2.46 5.48 5.48c0 1.4-.53 2.67-1.4 3.64Zm6.58-22.34c.12-.28.32-.52.58-.69.26-.17.56-.25.87-.24h6.75c.3-.01.6.07.86.22.26.16.46.39.59.67.05.07.06.16.04.25-.03.08-.1.15-.18.17L34.76 23c-.12.07-.26.07-.37 0l-4.54-2.35a.263.263 0 0 1-.16-.15.258.258 0 0 1 .03-.21Zm9.77 5.15c-.06.36-.24.69-.52.92-.28.24-.63.36-1 .36h-6.81c-.34 0-.68-.1-.95-.31a1.585 1.585 0 0 1-.62-1.23v-3.24c0-.28.17-.38.43-.25 1.41.73 2.82 1.47 4.23 2.2.09.06.2.09.31.09s.22-.03.31-.09c1.4-.73 2.8-1.46 4.21-2.18.04-.02.08-.04.13-.05a.243.243 0 0 1 .32.25v2.81c.01.24 0 .49-.03.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.2f1313e40ef4882cce66f1458ec5e7ee.svg";
export { ForwardRef as ReactComponent };